import useFormFieldMeta from "hooks/useFormFieldMeta";
import { Tooltip } from "antd";
import ErrorsSummary from "components/common/ErrorsSummary";

import { TableRowFieldProps } from "./types";
import { StyledTableRowField } from "./styles";

const TableRowField: React.FC<TableRowFieldProps> = ({ matcher, children }) => {
  const { errors } = useFormFieldMeta(matcher);

  return (
    <Tooltip
      title={!!errors.length && <ErrorsSummary {...{ errors }} />}
      color="red"
      placement="bottom"
    >
      <StyledTableRowField hasError={!!errors.length}>
        {children}
      </StyledTableRowField>
    </Tooltip>
  );
};

export default TableRowField;
